import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { shiftRemindersApi } from "../api/shiftRemindersApi";

const QUERY_KEY = ["perfil", "shift-reminders"];

export function useShiftRemindersQuery() {
  return useQuery({ queryKey: QUERY_KEY, queryFn: shiftRemindersApi.get });
}

// O PUT devolve a escolha já normalizada — grava direto no cache.
export function useUpdateShiftRemindersMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: shiftRemindersApi.update,
    onSuccess: (dados) => queryClient.setQueryData(QUERY_KEY, dados),
  });
}
